import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=5149e674&"
import script from "./Desk.vue?vue&type=script&lang=js&"
export * from "./Desk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports